/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessRestrictionStampFilter,
  AccessRestrictionStampGet,
  AddUserOrUserGroupBody,
  CreateAccessRestrictionStampBody,
  DeleteAccessRestrictionStampUserOrUserGroupBody,
  GetAccessRestrictionStampListBody,
  TableModel1AccessRestrictionStampUserAndUserGroupGet,
  UpdateAccessRestrictionStampBody,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccessRestrictionStamp<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name GetAccessRestrictionStampList
   * @summary Возвращает список грифов, которые доступны пользователю
   * @request POST:/accessRestrictionStamp/list
   * @secure
   * @response `200` `(AccessRestrictionStampGet)[]` Список доступных пользователю грифы доступа
   */
  getAccessRestrictionStampList = (data: GetAccessRestrictionStampListBody, params: RequestParams = {}) =>
    this.request<AccessRestrictionStampGet[], any>({
      path: `/accessRestrictionStamp/list`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name AccessRestrictionStampDetail
   * @summary Получить грриф ограничения доступа по идентификатору
   * @request GET:/accessRestrictionStamp/{id}
   * @secure
   * @response `200` `AccessRestrictionStampGet` Гриф ограничения доступа
   */
  accessRestrictionStampDetail = (id: string, params: RequestParams = {}) =>
    this.request<AccessRestrictionStampGet, any>({
      path: `/accessRestrictionStamp/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name DeleteAccessRestrictionStamp
   * @summary Удаляет гриф ограничения доступа по идентификатору
   * @request POST:/accessRestrictionStamp/{id}/delete
   * @secure
   * @response `200` `void` Success
   */
  deleteAccessRestrictionStamp = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accessRestrictionStamp/${id}/delete`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name CreateAccessRestrictionStamp
   * @summary Создает гриф ограничения доступа
   * @request POST:/accessRestrictionStamp/create
   * @secure
   * @response `200` `string` Идентификатор грифа ограничения доступа
   */
  createAccessRestrictionStamp = (data: CreateAccessRestrictionStampBody, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/accessRestrictionStamp/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name UpdateAccessRestrictionStamp
   * @summary Изменение грифа ограничения доступа
   * @request POST:/accessRestrictionStamp/{id}/update
   * @secure
   * @response `200` `void` Success
   */
  updateAccessRestrictionStamp = (id: string, data: UpdateAccessRestrictionStampBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accessRestrictionStamp/${id}/update`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name DeleteAccessRestrictionStampUserOrUserGroup
   * @summary Удаляет пользователя или группу пользователей у грифа ограничения доступа
   * @request POST:/accessRestrictionStamp/{id}/deleteUserOrUserGroup
   * @secure
   * @response `200` `void` Success
   */
  deleteAccessRestrictionStampUserOrUserGroup = (
    id: string,
    data: DeleteAccessRestrictionStampUserOrUserGroupBody,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/accessRestrictionStamp/${id}/deleteUserOrUserGroup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name AddUserOrUserGroup
   * @summary Добавляет пользователя или группу пользователей у грифа ограничения доступа
   * @request POST:/accessRestrictionStamp/{id}/addUserOrUserGroup
   * @secure
   * @response `200` `void` Success
   */
  addUserOrUserGroup = (id: string, data: AddUserOrUserGroupBody, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accessRestrictionStamp/${id}/addUserOrUserGroup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AccessRestrictionStamps
   * @name GetListUserAndUserGroup
   * @summary Возвращает список пользователей и групп пользователей у грифа ограничения доступа по идентификатору
   * @request POST:/accessRestrictionStamp/{id}/UserAndUserGroupList
   * @secure
   * @response `200` `TableModel1AccessRestrictionStampUserAndUserGroupGet` Идентификатор грифа ограничения доступа
   */
  getListUserAndUserGroup = (id: string, data: AccessRestrictionStampFilter, params: RequestParams = {}) =>
    this.request<TableModel1AccessRestrictionStampUserAndUserGroupGet, any>({
      path: `/accessRestrictionStamp/${id}/UserAndUserGroupList`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
